export const updateVariationBadges = () => {
    jQuery(document).ready(function($) {
        const findBadges = (target) =>
            $(target).closest('div.product-content, div.yith-quick-view-content').find('div.product-badges');

        $(document).on('found_variation', 'form.variations_form', function(event, variation) {
            const $badges = findBadges(event.target);

            if (!$badges.length) {
                return;
            }

            if (typeof $badges.data('defaultBadges') === 'undefined') {
                $badges.data('defaultBadges', $badges.html());
            }

            $badges.html(variation.product_badges_html || '');
        });

        $(document).on('reset_data', 'form.variations_form', function(event) {
            const $badges = findBadges(event.target);
            const initial = $badges.data('defaultBadges');

            if ($badges.length && typeof initial !== 'undefined') {
                $badges.html(initial);
            }
        });
    });
};
